import React from 'react';
import { FieldErrors, SetFieldValue, UseFormRegister } from 'react-hook-form';

interface UserInputProps {
    register: UseFormRegister<any>;
    label: string,
    name: string,
    setValue: SetFieldValue<any>;
    isRequired: boolean,
    errors: FieldErrors; // Generalized type to handle multiple field errors
    handleSteps: (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => void;
}

const UserInput: React.FC<UserInputProps> = ({ register, errors, handleSteps, label, name, setValue, isRequired }) => {

    return (
        <div>
            <label className="block text-sm font-light mb-2">
                {label} {isRequired ? '*' : ""}
            </label>
            <input
                type="text"
                {...register(name, {
                    required: isRequired,

                })}
                className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="User Name"
                onChange={(e) => {
                    handleSteps(e, name),
                        setValue(name, e.target.value)
                }}
            />
            {errors.Username?.type === 'required' && (
                <span role="alert" className="w-full text-red-500 bg-white text-xs my-1">
                    This is required
                </span>
            )}

        </div>
    );
};

export default UserInput;
